// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2000":"26c41b5b00ba320b","4202":"8a3acdddfc7c4fb4","4509":"99a72ada2d245ac7","8486":"78ba421241a96f06"}[chunkId] + ".css";
};